import { useEffect, useState } from 'react';
import { MapPin, Award } from 'lucide-react';
import PageLayout, { PageCTA } from '../components/PageLayout';
import { IMAGES, COMPANIES_OF_MONTH } from '../mock';
import { useLang } from '../i18n/LanguageContext';
import api from '../api';

export default function CompaniesPage() {
  const { t, lang } = useLang();
  const p = t('pages.companies');
  const [items, setItems] = useState(COMPANIES_OF_MONTH);
  useEffect(() => {
    api.get('/companies-of-month', { params: { lang } }).then((r) => r.data?.length && setItems(r.data)).catch(() => {});
  }, [lang]);

  return (
    <PageLayout crumb={p.breadcrumb} title={p.hero} subtitle={p.sub} heroImage={IMAGES.factory}>
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-2 justify-center mb-12">
            <Award className="w-6 h-6 text-brand-yellow" />
            <h2 className="text-3xl md:text-4xl font-bold text-brand-navy">{p.featured}</h2>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            {items.map((c) => (
              <div key={c.id} className="p-8 bg-gray-50 rounded-2xl border border-gray-100 hover-lift hover:border-brand-yellow hover:bg-white">
                <div className="font-bold text-brand-navy text-2xl">{c.name}</div>
                <div className="text-sm text-gray-500 mt-2 flex items-center gap-2">
                  <MapPin className="w-4 h-4 text-brand-yellow" /> {c.city} • {t('platform.founded')} {c.founded} • {c.employees}
                </div>
                <p className="text-gray-700 mt-5 leading-relaxed">{c.specialty}</p>
                <div className="mt-5">
                  <div className="text-xs font-semibold text-brand-navy uppercase tracking-wider mb-2">Produits / Products</div>
                  <div className="flex flex-wrap gap-2">
                    {c.products.map((prod, i) => (
                      <span key={i} className="text-xs px-3 py-1 bg-white border border-gray-200 rounded text-brand-navy">{prod}</span>
                    ))}
                  </div>
                </div>
                <div className="mt-4 flex flex-wrap gap-2">
                  {c.certifications.map((cert, i) => (
                    <span key={i} className="text-[10px] px-2 py-1 bg-brand-yellow/20 text-brand-navy rounded font-bold">{cert}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <PageCTA title={p.ctaTitle} body={p.ctaBody} />
    </PageLayout>
  );
}
